var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useRef, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
var Modal = function (props) {
    var _a = props.lockBodyScroll, lockBodyScroll = _a === void 0 ? true : _a, onCloseCallback = props.onClose, onEnteredCallback = props.onEntered, dialogProps = __rest(props, ["lockBodyScroll", "onClose", "onEntered"]);
    var dialog = useRef(null);
    var toggleScrollLock = useCallback(function (state) {
        if (dialog.current && lockBodyScroll) {
            var scrollerClass = dialogProps.scroll === "body" ? "MuiDialog-paperScrollBody" : "MuiDialog-paperScrollPaper";
            var scroller = dialog.current.getElementsByClassName(scrollerClass)[0];
            if (scroller)
                state ? disableBodyScroll(scroller) : enableBodyScroll(scroller);
        }
    }, [dialog, lockBodyScroll, dialogProps.scroll]);
    var handleClose = useCallback(function (event, reason) {
        onCloseCallback && onCloseCallback(event, reason);
    }, [onCloseCallback]);
    var handleEntered = useCallback(function (node, isAppearing) {
        toggleScrollLock(true);
        onEnteredCallback && onEnteredCallback(node, isAppearing);
    }, [toggleScrollLock, onEnteredCallback]);
    var handleExit = useCallback(function () {
        toggleScrollLock(false);
        clearAllBodyScrollLocks();
    }, [toggleScrollLock]);
    useEffect(function () {
        return function () {
            toggleScrollLock(false);
            clearAllBodyScrollLocks();
        };
    }, [toggleScrollLock]);
    return React.createElement(Dialog, __assign({ ref: dialog, onClose: handleClose, onEntered: handleEntered, onExit: handleExit }, dialogProps));
};
Modal.displayName = "Modal";
export default Modal;
